import React, { useEffect, useState, useContext } from 'react';
import check_icon from 'assests/svg/check_icon.svg';
import alert_warn from 'assests/svg/alert_warn.svg';
import alert_red from 'assests/svg/alert_red.svg';

import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import Select from 'b2b-ui-components-lib/lib/components/select';
import Input from 'b2b-ui-components-lib/lib/components/input';
import Button from 'b2b-ui-components-lib/lib/components/button';
import TextArea from 'b2b-ui-components-lib/lib/components/textarea';
import LeadTagsComponent from './LeadTagsComponent';
import Comments from './comments/comments';
import AttachmentFiles from './attachment-files/attachment-files';

import { getLeadTagsAsync, getDoaLifeCycleAsync } from 'home/view/upgrade-order/services';

import {
  LEAD_STATUS,
  DOA_STATUS,
  TOAST_TYPE,
  FIELD_ERROR,
  ACTIVE_TABS,
  KAM_MESSAGE_STATUS,
  CONTRACT_PERIOD_LIST,
  PRICE_TYPE_ENUM,
  PRICE_TYPES,
  DEFAULT_MONEY,
  HARDWARE_TYPE
} from 'home/view/upgrade-order/constants';

import { CONTEXT } from 'home/view/upgrade-order/context';

import {
  getErrMsg,
  numberWithCommas,
  getLeadStatus,
  getContractPeriod,
  getEligibleForRenewContract,
  getPlanPrice,
  numberValidator,
  getDoaStatus,
  getDoaAssignedToRole,
  getDoaAssignedToUsers,
  monthsToYear,
  getOldLineItemDetail,
  getPlanDetail,
  getHardwareType
} from 'home/view/upgrade-order/utils';

import './index.scss';

const DoaStatus = ({ leadStatus, doaStatus, createLead, pricingDetails: { customPricePlan } }) => {
  switch (leadStatus) {
    case LEAD_STATUS.PRICING_DOA_REJECTED: {
      return (
        <div className="network_status network_status_error" style={{ marginBottom: 18 }}>
          <div className="stauts_icon">
            <img src={alert_red} alt="check" />
          </div>
          <div className="status_text">
            Delegation of Authority Status: <strong>{`${customPricePlan ? 'Customized' : 'Standard'} price rejected.`}</strong>
            Kindly{' '}
            <span className="network_link" onClick={createLead}>
              create a new lead.
            </span>
          </div>
        </div>
      );
    }
    case LEAD_STATUS.PRICING_DOA_APPROVED:
    case LEAD_STATUS.LEAD_SUBMITTED:
    case LEAD_STATUS.KYC_IN_PROGRESS:
    case LEAD_STATUS.KYC_SUBMITTED: {
      const approvedTemplate = () => {
        return (
          <div className="network_status network_status_success" style={{ marginBottom: 18 }}>
            <div className="stauts_icon">
              <img src={check_icon} alt="check" />
            </div>
            <div className="status_text">
              Delegation of Authority Status: <strong>{`${customPricePlan ? 'Customized' : 'Standard'} price approved. `}</strong>
              <span>You may notify the customer to proceed with the order.</span>
            </div>
          </div>
        );
      };
      const rejectedTemplate = () => {
        return (
          <div className="network_status network_status_error" style={{ marginBottom: 18 }}>
            <div className="stauts_icon">
              <img src={alert_red} alt="check" />
            </div>
            <div className="status_text">
              Delegation of Authority Status: <strong>{`${customPricePlan ? 'Customized' : 'Standard'} price rejected.`}</strong>
              Kindly{' '}
              <span className="network_link" onClick={createLead}>
                create a new lead.
              </span>
            </div>
          </div>
        );
      };
      const approvedDOAStatues = doaStatus === DOA_STATUS.AUTO_APPROVED || doaStatus === DOA_STATUS.APPROVED || doaStatus === DOA_STATUS.PUSHED_LEAD_TO_KYC;
      const rejectedDOAStatues = doaStatus === DOA_STATUS.REJECTED;

      if (approvedDOAStatues) {
        approvedTemplate();
      }
      if (rejectedDOAStatues) {
        rejectedTemplate();
      }
      return approvedTemplate();
    }
    case LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT: {
      return (
        <div className="network_status network_status_pending" style={{ marginBottom: 18 }}>
          <div className="stauts_icon">
            <img src={alert_warn} alt="check" />
          </div>
          <div className="status_text">
            Delegation of Authority Status:{' '}
            {doaStatus === DOA_STATUS.CLARITY_REQUIRED && (
              <React.Fragment>
                <strong>Clarity Required </strong>
                <span>{`on ${customPricePlan ? 'Customized' : 'Standard'} price.`}</span>
              </React.Fragment>
            )}
            {doaStatus === DOA_STATUS.IN_PROGRESS && (
              <React.Fragment>
                <strong>In Progress </strong>
                <span>{`on ${customPricePlan ? 'Customized' : 'Standard'} price.`}</span>
              </React.Fragment>
            )}
          </div>
        </div>
      );
    }
    default: {
      return null;
    }
  }
};

const TitleComponent = React.memo(({ isExpanded, pricingDetails, totalCost, leadTags, setActiveTab, leadStatus, doaStatus, createLead, leadData, isDisabled }) => {
  const isDOAStatus = leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT || leadData.doaStatus === DOA_STATUS.APPROVED || leadData.doaStatus === DOA_STATUS.AUTO_APPROVED;

  return isExpanded ? (
    <div className="upgrade-header-open">
      <div>Configure Price Quote</div>
      {isDisabled() || isDOAStatus ? null : (
        <div className="sub-title" style={{ padding: '10px 0 16px 0' }}>
          You may{' '}
          <a
            role="button"
            href="javascript:void(0)"
            onClick={() => setActiveTab(ACTIVE_TABS.CUSTOM_PRICE)}
            style={{
              textDecoration: 'underline',
              fontWeight: 600
            }}
          >
            customize
          </a>{' '}
          the pricing by updating the Annual Recurring Charge and/or One-time Charge.
        </div>
      )}
      <DoaStatus leadStatus={leadStatus} doaStatus={doaStatus} createLead={createLead} pricingDetails={pricingDetails} />
      <LeadTagsComponent leadTags={leadTags} />
    </div>
  ) : (
    <ul className="upgrade-header-closed">
      <li
        key="pnq-title"
        style={{
          fontWeight: 600,
          fontSize: 16,
          color: '#0C0F12'
        }}
      >
        Configure Price Quote
      </li>
      {!!totalCost && <li key="total-price">{`Total Contract Value: ${totalCost}`}</li>}
      {pricingDetails.contractPeriod && <li key="contract-period">{`Contract Period: ${monthsToYear(pricingDetails.contractPeriod)} Year`}</li>}
    </ul>
  );
});

const KamPricingComponent = ({
  leadData = {},
  setLeadData = () => {},
  errors = {},
  setErrors = () => {},
  submitClicked = false,
  activeTab = '',
  setActiveTab = () => {},
  selectedContractPeriod = {},
  setSelectedContractPeriod = () => {},
  rentalCost = '',
  setRentalCost = () => {},
  otcCost = '',
  setOtcCost = () => {},
  createLead = () => {},
  commentText = {},
  setCommentText = () => {},
  attachments = {},
  setAttachment = () => {},
  selectedBandwidth = {},
  setLowerPriceBw = () => {},
  loading = false,
  checkErrors = () => {},
  onSubmitClick = () => {},
  onCancelClick = () => {},
  isSubmitDisabled = () => {},
  isCancelDisabled = () => {}
}) => {
  const { setToastMsg, pnqToken } = useContext(CONTEXT);

  const pricingDetails = {
    leadStatus: getLeadStatus(leadData),
    doaStatus: getDoaStatus(leadData),
    doaAssignedToRole: getDoaAssignedToRole(leadData),
    doaAssignedToUsers: getDoaAssignedToUsers(leadData),
    contractPeriod: getContractPeriod(leadData), // in months
    customPricePlan: getPlanPrice(leadData) && getPlanPrice(leadData).customPricePlan,
    eligibleForRenewContract: getEligibleForRenewContract(leadData)
  };

  const [accordionMeta, setAccordionMeta] = useState({
    isExpanded: true
  });
  const [leadTags, setLeadTags] = useState([]);
  const [totalCost, setTotalCost] = useState(DEFAULT_MONEY);
  const [formTouched, setFormTouched] = useState({
    rentalCost: false,
    otcCost: false,
    clarityRequired: false
  });
  const [commentHistory, setCommentHistory] = useState([]);
  const [status, setStatus] = useState({ message: '', cssClass: '' });
  const [selectedPriceType, setSelectedPriceType] = useState({});

  const getStatus = ({ leadStatus, doaStatus, isLowerPriceBw, isNonStandardHardware, isZeroRateCard, doaAssignedToRole, doaAssignedToUsers }) => {
    let message = '';
    let cssClass = '';
    let doaDetail = '';

    if (doaAssignedToRole) {
      if (doaAssignedToUsers?.name) {
        doaDetail = doaDetail + doaAssignedToUsers?.name;
      }

      if (doaAssignedToUsers?.email) {
        doaDetail = doaDetail + `, ${doaAssignedToUsers?.email}`;
      }

      if (doaAssignedToUsers?.phoneNumber) {
        doaDetail = doaDetail + `, ${doaAssignedToUsers?.phoneNumber}`;
      }
    }

    if (
      leadStatus === LEAD_STATUS.LEAD_SUBMITTED ||
      leadStatus === LEAD_STATUS.PRICING_DOA_APPROVED ||
      leadStatus === LEAD_STATUS.KYC_IN_PROGRESS ||
      leadStatus === LEAD_STATUS.KYC_SUBMITTED
    ) {
      message = KAM_MESSAGE_STATUS.LEAD_SUBMITTED;
      cssClass = 'success';
    } else if (leadStatus === LEAD_STATUS.PRICING_DOA_REJECTED && doaStatus === DOA_STATUS.REJECTED) {
      message = KAM_MESSAGE_STATUS.DOA_REJECTED_PRICING;
      if (doaDetail) {
        message = message + ` ( ${doaDetail} ) `;
      }
      cssClass = 'error';
    } else if (leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION) {
      message = KAM_MESSAGE_STATUS.CUSTOMIZED_PRICING;
      cssClass = 'warning';

      if (isNonStandardHardware || isZeroRateCard) {
        message = KAM_MESSAGE_STATUS.CUSTOMIZED_PRICING;
      } else if (isLowerPriceBw) {
        message = KAM_MESSAGE_STATUS.LOWER_BW_PRICING;
      }
    } else if (doaStatus === DOA_STATUS.IN_PROGRESS && leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT) {
      message = KAM_MESSAGE_STATUS.DOA_PRICING_REQUEST;
      if (doaDetail) {
        message = message + ` ( ${doaDetail} ) `;
      }
      cssClass = 'success';
    } else if (doaStatus === DOA_STATUS.CLARITY_REQUIRED && leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT) {
      message = KAM_MESSAGE_STATUS.DOA_CLARITY_REQUEST;
      if (doaDetail) {
        message = message + ` ( ${doaDetail} ) `;
      }
      cssClass = 'error';
    }

    return {
      cssClass,
      message
    };
  };

  useEffect(() => {
    getLeadTags();
    getHistory();
    setSelectedPriceType(PRICE_TYPES[0]);
  }, []);

  const getPricing = (selectedBandwidth, leadData) => {
    let rental = '';
    let oneTimeCharge = '';
    let standardRate = false;

    if (
      selectedBandwidth &&
      selectedBandwidth.key &&
      (leadData.leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED || leadData.leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION)
    ) {
      rental = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.prices && selectedBandwidth.plan.prices.RATE.charge;
      oneTimeCharge = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.prices && selectedBandwidth.plan.prices.RATE.otc;
      standardRate = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.standardRate;
    } else {
      rental = getPlanPrice(leadData) && getPlanPrice(leadData).rental;
      oneTimeCharge = getPlanPrice(leadData) && getPlanPrice(leadData).oneTimeCharge;
      standardRate = getPlanDetail(leadData) && getPlanDetail(leadData).standardRate;
    }

    return {
      rental,
      oneTimeCharge,
      standardRate
    };
  };

  const isLowerPricing = (selectedBandwidth, leadData) => {
    let isLowerPriceBw = false;

    const hardwareType = getHardwareType(leadData);

    const { rental, standardRate } = getPricing(selectedBandwidth, leadData);

    const isNonStandardHardware = (hardwareType && hardwareType === HARDWARE_TYPE.NON_STANDARD) || false;
    const isZeroRateCard = parseInt(rental) === 0 && !standardRate;

    if (rental < (getOldLineItemDetail(leadData) && getOldLineItemDetail(leadData).price && getOldLineItemDetail(leadData).price.rental)) {
      isLowerPriceBw = true;
    } else {
      isLowerPriceBw = false;
    }

    return {
      isLowerPriceBw,
      isNonStandardHardware,
      isZeroRateCard
    };
  };

  useEffect(() => {
    const leadStatus = pricingDetails.leadStatus;
    const doaStatus = pricingDetails.doaStatus;
    const doaAssignedToRole = pricingDetails?.doaAssignedToRole;
    const doaAssignedToUsers = pricingDetails?.doaAssignedToUsers;

    // bw lower pricing case
    const { isLowerPriceBw, isNonStandardHardware, isZeroRateCard } = isLowerPricing(selectedBandwidth, leadData);

    let status = getStatus({
      leadStatus,
      doaStatus,
      doaAssignedToRole,
      doaAssignedToUsers,
      isLowerPriceBw,
      isNonStandardHardware,
      isZeroRateCard
    });

    setStatus(status);
    setLowerPriceBw(isLowerPriceBw);
    setActiveTab((pricingDetails && pricingDetails.customPricePlan) || isLowerPriceBw ? ACTIVE_TABS.CUSTOM_PRICE : ACTIVE_TABS.STANDARD_PRICE);
  }, [pricingDetails.leadStatus, pricingDetails.doaStatus, pricingDetails.customPricePlan, selectedBandwidth, leadData]);

  useEffect(() => {
    if (activeTab === ACTIVE_TABS.STANDARD_PRICE) {
      const rental = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.prices && selectedBandwidth.plan.prices.RATE.charge;
      const oneTimeCharge = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.prices && selectedBandwidth.plan.prices.RATE.otc;

      setRentalCost(rental);
      setOtcCost(oneTimeCharge);
    }
  }, [selectedBandwidth]);

  useEffect(() => {
    if (pricingDetails.contractPeriod) {
      const yrValue = Math.floor(monthsToYear(pricingDetails.contractPeriod));
      const selectedItem = CONTRACT_PERIOD_LIST.find((item) => parseInt(item.key) === parseInt(yrValue));
      setSelectedContractPeriod(selectedItem ? selectedItem : { key: yrValue, displayName: `${yrValue} years` });
    } else {
      setSelectedContractPeriod(CONTRACT_PERIOD_LIST[0]);
    }
  }, [pricingDetails.contractPeriod]);

  useEffect(() => {
    const modifiedOtcCost = otcCost ? parseInt(otcCost) : 0;
    const totalSum = rentalCost * selectedContractPeriod.key + modifiedOtcCost;
    setTotalCost(totalSum);
  }, [selectedContractPeriod, rentalCost, otcCost]);

  useEffect(() => {
    const rental_rate = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.prices && selectedBandwidth.plan.prices.RATE.charge;
    const oneTimeCharge_rate = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.prices && selectedBandwidth.plan.prices.RATE.otc;
    const default_rental = getPlanPrice(leadData) && getPlanPrice(leadData).rental;
    const default_oneTimeCharge = getPlanPrice(leadData) && getPlanPrice(leadData).oneTimeCharge;

    if (pricingDetails && pricingDetails.contractPeriod) {
      const yrValue = Math.floor(monthsToYear(pricingDetails.contractPeriod));
      const selectedItem = CONTRACT_PERIOD_LIST.find((item) => parseInt(item.key) === parseInt(yrValue));
      setSelectedContractPeriod(selectedItem ? selectedItem : { key: yrValue, displayName: `${yrValue} years` });
    } else {
      setSelectedContractPeriod(CONTRACT_PERIOD_LIST[0]);
    }

    if (activeTab === ACTIVE_TABS.STANDARD_PRICE) {
      setSelectedPriceType(PRICE_TYPES[0]);
      setRentalCost(rental_rate);
      setOtcCost(oneTimeCharge_rate);
      handleCostChange('rentalCost', rental_rate);
      handleCostChange('otcCost', oneTimeCharge_rate);
    } else {
      const preFillPrices =
        pricingDetails.leadStatus === LEAD_STATUS.LEAD_SUBMITTED ||
        pricingDetails.leadStatus === LEAD_STATUS.KYC_IN_PROGRESS ||
        pricingDetails.leadStatus === LEAD_STATUS.KYC_SUBMITTED ||
        pricingDetails.leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT;

      if (!preFillPrices) {
        setRentalCost('');
        setOtcCost('');
        handleCostChange('rentalCost', '');
        handleCostChange('otcCost', '');
      } else {
        setRentalCost(default_rental);
        setOtcCost(default_oneTimeCharge);
        handleCostChange('rentalCost', default_rental);
        handleCostChange('otcCost', default_oneTimeCharge);
      }
    }
  }, [activeTab, leadData, pricingDetails.leadStatus]);

  const getHistory = async () => {
    try {
      const doaId = leadData && leadData.doaId;
      if (doaId) {
        const { res, err } = await getDoaLifeCycleAsync(doaId);
        const result = await (res && res.data && res.data.result);
        if (err) {
          const errorMsg = getErrMsg(err);
          setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
          throw new Error(errorMsg);
        }
        Array.isArray(result) && setCommentHistory(result);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getLeadTags = async () => {
    try {
      const { res, err } = await getLeadTagsAsync(pnqToken);
      const result = await (res && res.data && res.data.result);

      if (err) {
        const errorMsg = getErrMsg(err);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        throw new Error(errorMsg);
      }
      setLeadTags(result);
    } catch (err) {
      const errorMsg = getErrMsg(err);
      setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
      throw new Error(errorMsg);
    }
  };

  const validateAndUpdateErrors = (key, value) => {
    let errorList = [];

    const { isLowerPriceBw } = isLowerPricing(selectedBandwidth, leadData);
    const existingRental = getOldLineItemDetail(leadData) && getOldLineItemDetail(leadData).price && getOldLineItemDetail(leadData).price.rental;

    key !== 'clarityRequired' && (errorList = numberValidator(value) || []);

    if (!value || parseInt(value) === 0) {
      !errorList.includes(FIELD_ERROR.REQUIRED) && errorList.unshift(FIELD_ERROR.REQUIRED);
      key === 'otcCost' && parseInt(value) === 0 && errorList.shift();
      key === 'rentalCost' && parseInt(value) === 0 && errorList.shift() && errorList.unshift(FIELD_ERROR.ARC_ERR_MSG);
    }

    if (!pricingDetails.eligibleForRenewContract && isLowerPriceBw && key === 'rentalCost' && parseInt(value) < parseInt(existingRental)) {
      if (errorList.length > 0) {
        errorList.shift();
      }

      errorList.unshift(FIELD_ERROR.LOW_PRICE_MSG);
    }

    setErrors((errors) => ({
      ...errors,
      [key]: errorList
    }));
    setFormTouched((formTouched) => ({
      ...formTouched,
      [key]: true
    }));
  };

  const handleCostChange = (key, value) => {
    validateAndUpdateErrors(key, value);
  };

  const onFileUploaded = (filesInfo) => {
    if (Array.isArray(filesInfo)) {
      const fileAttachements = filesInfo
        .filter(({ isUploaded }) => isUploaded)
        .map(({ content, file }) => {
          return { name: file.name, file: content.split(',')[1] };
        });
      setAttachment(fileAttachements);
    }
  };

  const handlePriceTypeChange = (value) => {
    let rental = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.prices && selectedBandwidth.plan.prices.RATE.charge;
    let oneTimeCharge = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.prices && selectedBandwidth.plan.prices.RATE.otc;
    if (value.key === PRICE_TYPE_ENUM.FLOOR_RATE) {
      rental = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.prices && selectedBandwidth.plan.prices.FLOOR_RATE.charge;
      oneTimeCharge = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.prices && selectedBandwidth.plan.prices.FLOOR_RATE.otc;
    }
    setRentalCost(rental);
    setOtcCost(oneTimeCharge);
    setSelectedPriceType(value);
  };

  const isDisabled = () => {
    return (
      pricingDetails.leadStatus === LEAD_STATUS.LEAD_SUBMITTED ||
      pricingDetails.leadStatus === LEAD_STATUS.KYC_IN_PROGRESS ||
      pricingDetails.leadStatus === LEAD_STATUS.KYC_SUBMITTED ||
      (pricingDetails.leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT && leadData.doaStatus === DOA_STATUS.IN_PROGRESS)
    );
  };

  const getStandardPriceTabClass = () => {
    const { isZeroRateCard } = isLowerPricing(selectedBandwidth, leadData);

    if (isZeroRateCard) {
      return 'disabled';
    }

    if (activeTab === ACTIVE_TABS.STANDARD_PRICE) {
      return 'active';
    }

    return '';
  };

  return (
    <div className="kam-pricing-details upgrade-accordion">
      <Accordion
        // autoScrollOnExpand={toast.show ? false : true}
        autoScrollOnExpand
        title={
          <TitleComponent
            isExpanded={accordionMeta.isExpanded}
            pricingDetails={pricingDetails}
            totalCost={totalCost}
            leadTags={leadTags}
            setActiveTab={setActiveTab}
            createLead={createLead}
            leadStatus={pricingDetails.leadStatus}
            doaStatus={pricingDetails.doaStatus}
            leadData={leadData}
            isDisabled={isDisabled}
          />
        }
        isExpanded={accordionMeta.isExpanded}
        onExpandClick={() =>
          setAccordionMeta((accordionMeta) => ({
            ...accordionMeta,
            isExpanded: !accordionMeta.isExpanded
          }))
        }
        variant="round"
      >
        <div className="upgrade-body" style={{ marginTop: 25 }}>
          <div className="pricing-tabs">
            <ul>
              <li className={getStandardPriceTabClass()} onClick={() => setActiveTab(ACTIVE_TABS.STANDARD_PRICE)}>
                Standard Price
              </li>
              <div className="tooltip_wrap">
                <div className="tooltip_list">
                  <li className={activeTab === ACTIVE_TABS.CUSTOM_PRICE ? 'active' : ''} onClick={() => setActiveTab(ACTIVE_TABS.CUSTOM_PRICE)}>
                    Customize Price
                  </li>
                  <div className="tooltip custom-price">
                    <div className="tooltip_content">Customise the pricing by updating ARC and OTC</div>
                  </div>
                </div>
              </div>
            </ul>
          </div>
          <div className="row">
            <div className="flg-lg-4 flg-md-6 flg-sm-12">
              <div className="control_group">
                <Select
                  placeholder=""
                  label="Contract Period"
                  value={selectedContractPeriod}
                  onChange={(value) => setSelectedContractPeriod(value)}
                  options={CONTRACT_PERIOD_LIST}
                  required
                  touched
                  disabled={isDisabled()}
                />
              </div>
            </div>
            {activeTab === ACTIVE_TABS.STANDARD_PRICE && (
              <div className="flg-lg-4 flg-md-6 flg-sm-12">
                <div className="control_group">
                  <Select
                    placeholder=""
                    label="Type of Price"
                    value={selectedPriceType}
                    onChange={handlePriceTypeChange}
                    options={PRICE_TYPES}
                    required
                    touched
                    disabled={isDisabled()}
                  />
                </div>
              </div>
            )}
          </div>
          <div className="row">
            <div className="flg-lg-4 flg-md-6 flg-sm-12">
              {activeTab === ACTIVE_TABS.STANDARD_PRICE ? (
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">Annual Recurring Charge</label>
                    <div className="value">&#8377; {rentalCost ? numberWithCommas(rentalCost) : DEFAULT_MONEY}</div>
                  </div>
                </div>
              ) : (
                <Input
                  type="text"
                  label="Annual Recurring Charge"
                  name="rentalCost"
                  value={rentalCost}
                  onChange={(value) => {
                    handleCostChange('rentalCost', value);
                    setRentalCost(value);
                  }}
                  errors={submitClicked || formTouched.rentalCost ? errors.rentalCost : []}
                  required
                  touched
                  disabled={isDisabled()}
                />
              )}
            </div>
            <div className="flg-lg-4 flg-md-6 flg-sm-12">
              {activeTab === ACTIVE_TABS.STANDARD_PRICE ? (
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">One-time Charge</label>
                    <div className="value">&#8377; {otcCost ? numberWithCommas(otcCost) : rentalCost ? otcCost : DEFAULT_MONEY}</div>
                  </div>
                </div>
              ) : (
                <Input
                  type="text"
                  label="One-time Charge"
                  name="otcCost"
                  value={otcCost}
                  onChange={(value) => {
                    handleCostChange('otcCost', value);
                    setOtcCost(value);
                  }}
                  errors={submitClicked || formTouched.otcCost ? errors.otcCost : []}
                  required
                  touched
                  disabled={isDisabled()}
                />
              )}
            </div>
            <div className="flg-lg-4 flg-md-6 flg-sm-12">
              <div className="control_group">
                <div className="prefield_details">
                  <label className="field_label">Total Contract Value</label>
                  <div className="value">&#8377; {totalCost ? numberWithCommas(totalCost) : 0}</div>
                  <div className="inchargeContent field_label" style={{ top: 10 }}>
                    (Excluding GST rates as applicable)
                  </div>
                </div>
              </div>
            </div>
          </div>
          {activeTab === ACTIVE_TABS.CUSTOM_PRICE && pricingDetails.doaStatus === DOA_STATUS.CLARITY_REQUIRED && (
            <div className="row">
              <div className="flg-lg-12 flg-md-6 flg-sm-12">
                <div className="comment_box">
                  <p>Add a comment and attachments for customized pricing if any.</p>
                  <div className="textarea_field">
                    <TextArea
                      label="Reason for customised price"
                      placeholder="Enter Description"
                      name="clarityRequired"
                      onChange={(value) => {
                        validateAndUpdateErrors('clarityRequired', value);
                        setCommentText(value);
                      }}
                      value={commentText}
                      maxLength={250}
                      required
                      touched
                      disabled={isDisabled()}
                      errors={submitClicked || formTouched.clarityRequired ? errors.clarityRequired : []}
                    />
                  </div>
                  {((leadData && leadData.doaStatus === DOA_STATUS.CLARITY_REQUIRED) || (leadData && leadData.leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION)) && (
                    <div className="attachment_section">
                      <AttachmentFiles onFileUploaded={onFileUploaded} />
                    </div>
                  )}
                  <div className="comments_section">
                    <Comments comments={commentHistory} remarks={leadData && leadData.remarks} />
                  </div>
                </div>
              </div>
            </div>
          )}
          {status && status.message && (
            <div className="accordion-footer" style={{ paddingTop: 35 }}>
              <div className="info_strip">
                <div className={`info_text ${status && status.cssClass}`}>Status: {status && status.message}</div>
              </div>
            </div>
          )}
          {/* <div className="action_button">
            <Button variant="outlinebtn" displayName="Cancel" onClick={onCancelClick} disabled={isCancelDisabled()}></Button>
            <Button displayName="Next" disabled={loading || isSubmitDisabled()} onClick={onSubmitClick}>
              {loading && <span className="loading_icon"></span>}
            </Button>
          </div> */}
        </div>
      </Accordion>
    </div>
  );
};

KamPricingComponent.propTypes = {};

export default KamPricingComponent;
